/**
 * Service provider for PouchDB
 * @name functions.ts
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Injectable } from '@angular/core';
//import { ToastController, NavController, Platform, AlertController, LoadingController, ModalController } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
declare var require: any;
import 'rxjs/add/operator/map';
import { HttpClient, HttpHeaders } from '@angular/common/http';
const { parseAsync } = require('json2csv');
declare global {
    interface Navigator {
        msSaveBlob?: (blob: any, defaultName?: string) => boolean
    }
}

@Injectable({
    providedIn: 'root',
})
export class Functions {
    buttonData = [
        {
            id: 'Wwwc',
            title: 'WW/WC',
            className: 'WwwcTool',
            icon: 'sun',
        },
        {
            id: 'WwwcRegion',
            title: 'Window by Region',
            className: 'WwwcRegionTool',
            icon: 'stop',
        },
        {
            id: 'Magnify',
            title: 'Magnify',
            className: 'MagnifyTool',
            icon: 'circle',
        },
        {
            id: 'ArrowAnnotate',
            title: 'Annotate Arrow',
            className: 'ArrowAnnotateTool',
            icon: 'text-width',
        },
        {
            id: 'invert',
            title: 'Invert',
            className: '',
            icon: 'adjust',
        },
        {
            id: 'Zoom',
            title: 'Zoom',
            className: 'ZoomTool',
            icon: 'search',
        },
        {
            id: 'Pan',
            title: 'Pan',
            className: 'PanTool',
            icon: 'arrows',
        },
        {
            id: 'stackScroll',
            title: 'Stack Scroll',
            className: '',
            icon: 'bars',
        },
        {
            id: 'Length',
            title: 'Length Measurement',
            className: 'LengthTool',
            icon: 'arrows-v',
        },
        {
            id: 'Angle',
            title: 'Angle Measurement',
            className: 'AngleTool',
            icon: 'angle-double-up',
        },
        {
            id: 'CobbAngle',
            title: 'Compass',
            className: 'CobbAngleTool',
            icon: 'compass',
        },
        {
            id: 'Bidirectional',
            title: 'Bidirectional Measurement',
            className: 'BidirectionalTool',
            icon: 'arrows-alt',
        },
        {
            id: 'DragProbe',
            title: 'Pixel Probe',
            className: 'DragProbeTool',
            icon: 'circle-dot',
        },
        {
            id: 'Eraser',
            title: 'Eraser',
            className: 'EraserTool',
            icon: 'eraser',
            enabled: false
        },
        {
            id: 'Brush',
            title: 'Brush',
            className: 'BrushTool',
            icon: 'paint-brush',
            stackneeded: true,
        },
        {
            id: 'CircleScissors',
            title: 'Circle Scissors',
            className: 'CircleScissorTool',
            icon: 'circle-notch',
            stackneeded: true,
        },
        {
            id: 'RectangleScissors',
            title: 'Rectangle Scissors',
            className: 'RectangleScissorTool',
            icon: 'note-sticky',
            stackneeded: true,
        },
        {
            id: 'FreehandScissors',
            title: 'Freehand Scissors',
            className: 'FreehandScissorTool',
            icon: 'hand-scissors',
            stackneeded: true,
        },
        {
            id: 'EllipticalRoi',
            title: 'Elliptical ROI',
            className: 'EllipticalRoiTool',
            icon: 'bezier-curve',
        },
        {
            id: 'RectangleRoi',
            title: 'Rectangle ROI',
            className: 'RectangleRoiTool',
            icon: 'vector-square',
        },
        {
            id: 'FreehandRoi',
            title: 'Freehand ROI',
            className: 'FreehandRoiTool',
            icon: 'magic',
        },
        {
            id: 'rotate',
            title: 'Rotate Left',
            className: '',
            icon: 'mail-forward',
        },
        {
            id: 'vflip',
            title: 'Flip Vertical',
            className: '',
            icon: 'ellipsis-v',
        },
        {
            id: 'hflip',
            title: 'Flip Horizontal',
            className: '',
            icon: 'ellipsis-h',
        },
        {
            id: 'ScaleOverlay',
            title: 'Overlay a Scale',
            className: 'ScaleOverlayTool',
            icon: 'i-cursor',
        },
        {
            id: 'Lung',
            type: 'text',
            className: 'ww_wc',
            width: 1600,
            center: -600
        },
        {
            id: 'Soft Tissue',
            type: 'text',
            className: 'ww_wc',
            width: 400,
            center: 20
        },
        {
            id: 'Bone',
            type: 'text',
            className: 'ww_wc',
            width: 2000,
            center: 300
        },
        {
            id: 'Clear',
            title: 'Reset Viewport',
            className: 'ClearTool',
            icon: 'undo',
        },
    ];
    particlesOptions = {
        fpsLimit: 60,
        particles: {
            number: {
                value: 20,
                density: {
                    enable: true,
                    value_area: 800
                }
            },
            color: {
                value: "#ffffff"
            },
            shape: {
                type: "circle",
                stroke: {
                    width: 0,
                    color: "#000000"
                },
                polygon: {
                    nb_sides: 5
                },
                image: {
                    src: "images/github.svg",
                    width: 100,
                    height: 100
                }
            },
            opacity: {
                value: 1,
                random: false,
                anim: {
                    enable: false,
                    speed: 1,
                    opacity_min: 0.1,
                    sync: false
                }
            },
            size: {
                value: 30,
                random: true,
                anim: {
                    enable: false,
                    speed: 40,
                    size_min: 0.1,
                    sync: false
                }
            },
            line_linked: {
                enable: true,
                distance: 150,
                color: "#ffffff",
                opacity: 1,
                width: 1
            },
            move: {
                enable: true,
                speed: 2,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                attract: {
                    enable: false,
                    rotateX: 600,
                    rotateY: 1200
                }
            }
        },
        interactivity: {
            detect_on: "canvas",
            events: {
                onHover: {
                    enable: true,
                    mode: "bubble",
                    parallax: {
                        enable: false,
                        force: 60,
                        smooth: 10
                    }
                },
                onClick: {
                    enable: true,
                    mode: "push"
                },
                resize: true
            },
            modes: {
                grab: {
                    distance: 400,
                    lineLinked: {
                        opacity: 1
                    }
                },
                bubble: {
                    distance: 400,
                    size: 100,
                    duration: 2,
                    opacity: 1,
                    speed: 3
                },
                repulse: {
                    distance: 200
                },
                push: {
                    particles_nb: 4
                },
                remove: {
                    particles_nb: 2
                }
            }
        },
        backgroundMask: {
            enable: true,
            cover: {
                value: {
                    r: 255,
                    g: 255,
                    b: 255
                }
            }
        },
        retina_detect: true,
        background: {
            image: "url('assets/img/bg.jpg')",
            position: "cover"
        }
    };
    /**
     * Constructor
     */
    constructor(public http: HttpClient,) {

    }

    setObj(old) {
        let newobj = {};
        let keys = Object.keys(old);
        keys.map(key => {
            newobj[key] = old[key];
        })
        return newobj;
    }
    removeDel(html) {
        let result = new RegExp("<delete" + "(.*?)" + "</delete>", 'g');
        let res = html.replace(result, '');
        return res;
    }

    getFileIcon(filename) {
        let ext = filename.split('.').pop();
        if (ext == 'png') {
            return 'assets/img/icons/png.png';
        }
        else if (ext == 'jpg' || ext == 'jpeg') {
            return 'assets/img/icons/png.png';
        }
        else if (ext == 'pdf') {
            return 'assets/img/icons/pdf.png';
        }
        else if (ext == 'mp4') {
            return 'assets/img/icons/mp4.png';
        }
        else if (ext == 'json') {
            return 'assets/img/icons/obj.png';
        }
        else if (ext == 'dcm') {
            return 'assets/img/icons/dicom.png';
        }
        else {
            return 'assets/img/icons/image.png';
        }
    }


    exportCSV(datas, mode = "file") {
        const fields = Object.keys(datas[0]);
        const opts = { fields: fields, eol: '\r\n' };

        parseAsync(datas, opts)
            .then(csv => {
                var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                var csvURL = null;
                if (navigator.msSaveBlob) {
                    csvURL = navigator.msSaveBlob(csvData, mode + '.csv');
                } else {
                    csvURL = window.URL.createObjectURL(csvData);
                }
                var tempLink = document.createElement('a');
                tempLink.href = csvURL;
                tempLink.setAttribute('download', mode + '.csv');
                tempLink.click();
                URL.revokeObjectURL(csvURL);
            })
            .catch(err => console.error(err));
    }

    exportJSON(obj, name) {
        var csvData = new Blob([JSON.stringify(obj, null, 4)], { type: 'text/json;' });
        var csvURL = null;
        if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, name + '.json');
        } else {
            csvURL = window.URL.createObjectURL(csvData);
        }
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', name + '.json');
        tempLink.click();
        window.URL.revokeObjectURL(csvURL);
    }

    csvJSON(csv) {

        var lines = csv.split("\n");

        var result = [];

        var headers = lines[0].split(",");

        for (var i = 1; i < lines.length; i++) {

            var obj = {};
            var currentline = lines[i].split(",");

            for (var j = 0; j < headers.length; j++) {
                obj[headers[j]] = currentline[j];
            }

            result.push(obj);

        }

        //return result; //JavaScript object
        return JSON.stringify(result); //JSON
    }
}